import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "section-catalog" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "card card-catalog" }
const _hoisted_5 = { class: "mb-4 transition-y card-body" }
const _hoisted_6 = { class: "position-relative mb-3" }
const _hoisted_7 = { class: "image-box" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-12 fs-15 mb-0" }
const _hoisted_11 = { class: "fw-medium" }
const _hoisted_12 = { class: "col-12 fs-15 mb-0" }
const _hoisted_13 = { class: "fw-medium" }
const _hoisted_14 = { class: "col-12 fs-15 mb-0" }
const _hoisted_15 = { class: "fw-medium" }
const _hoisted_16 = { class: "col-12 fs-15 mb-0" }
const _hoisted_17 = { class: "fw-medium" }
const _hoisted_18 = { class: "col-12 fs-15 mb-0" }
const _hoisted_19 = { class: "fw-bold" }
const _hoisted_20 = { class: "col-12 fs-15 mt-4 text-center" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "col-lg-12" }
const _hoisted_23 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_24 = { class: "card-body p-4" }
const _hoisted_25 = { key: 1 }

import { defineComponent, ref } from "vue";
import Pagination from "@/components/Common/Pagination.vue";
import { useItemStore } from "@/stores/management/item";
import ProductsFilter from "@/components/Pages/Management/Catalog/ProductsFilter.vue";
import router from "@/router";


export default /*@__PURE__*/_defineComponent({
  __name: 'ListCatalog',
  setup(__props) {

const itemStore = useItemStore();
const listCatalogs = ref<any>();
const page = ref(1);
const limit = ref(12);
const totalItem = ref(0);

const loadListProduct = async (query = "") => {
  const { success, message } = await itemStore.dispatchGetCatalogs(
    page.value,
    limit.value,
    query
  );
  if (success) {
    listCatalogs.value = await itemStore.items.items;
    totalItem.value = await itemStore.items.total;
  }
};

const updatePage = (data: any) => {
  page.value = data;
  loadListProduct();
};

loadListProduct();

const toDetailProduct = (id = 0) => {
  router.push("/management/catalog/detail/" + id);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ProductsFilter, { onSearchByQuery: loadListProduct }),
    (totalItem.value > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listCatalogs.value, (product) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-lg-3 col-sm-6 mb-4",
                  key: product.id
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("img", {
                            src: product.image_link,
                            class: "rounded-3",
                            alt: "product"
                          }, null, 8, _hoisted_8)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _cache[0] || (_cache[0] = _createTextVNode(" MSG CODE : ")),
                          _createElementVNode("span", _hoisted_11, _toDisplayString(product.msg_code), 1)
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _cache[1] || (_cache[1] = _createTextVNode(" IMPA CODE : ")),
                          _createElementVNode("span", _hoisted_13, _toDisplayString(product.impa_code), 1)
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _cache[2] || (_cache[2] = _createTextVNode(" Category : ")),
                          _createElementVNode("span", _hoisted_15, _toDisplayString(product.category_name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _cache[3] || (_cache[3] = _createTextVNode(" Group Category : ")),
                          _createElementVNode("span", _hoisted_17, _toDisplayString(product.group_category_name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _cache[4] || (_cache[4] = _createTextVNode(" Item : ")),
                          _createElementVNode("span", _hoisted_19, _toDisplayString(product.name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("button", {
                            class: "btn btn-primary btn-sm text-white",
                            onClick: ($event: any) => (toDetailProduct(product?.id))
                          }, " View ", 8, _hoisted_21)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(Pagination, {
                      onPageChange: updatePage,
                      items: limit.value,
                      total: totalItem.value
                    }, null, 8, ["items", "total"])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_25, _cache[5] || (_cache[5] = [
          _createElementVNode("div", { class: "card bg-white" }, [
            _createElementVNode("div", { class: "transition-y card-body p-5" }, [
              _createElementVNode("div", { class: "card-content d-flex justify-content-center align-items-center empty-state" }, [
                _createElementVNode("div", { class: "fs-2" }, "Data Not Found")
              ])
            ])
          ], -1)
        ])))
  ], 64))
}
}

})